"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHeader = void 0;
const fetchHeader = (headers, key) => {
    const headersWithoutCase = Object.keys(headers).reduce((result, originalKey) => {
        const key = originalKey.toLowerCase();
        const originalHeaderValue = headers[originalKey];
        if (!originalHeaderValue) {
            return result;
        }
        return {
            ...result,
            [key]: originalHeaderValue,
        };
    }, {});
    return headersWithoutCase[key.toLowerCase()];
};
exports.fetchHeader = fetchHeader;
//# sourceMappingURL=Header.js.map